import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';
import { startOverflowDetector } from './lib/overflowDetector';
import { startStaleChunkReload } from './lib/staleChunkReload';

startOverflowDetector(); // dev-only: flags any element wider than the viewport
startStaleChunkReload(); // a tab left open across a deploy reloads instead of breaking

const rootEl = document.getElementById('root');
// A prerendered `/` (scripts/prerender-blog.js) carries the landing page's HTML, which an inline
// head script hides for a returning signed-in user (who gets the Dashboard instead). Dropping
// the marker here, right before React replaces that HTML, lets whatever React renders show.
rootEl.removeAttribute('data-prerendered');
const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
        <App />
      </GoogleOAuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);
